// extracted by mini-css-extract-plugin
export default {"bar":"RoomAssignmentBar_bar__Otkex","show":"RoomAssignmentBar_show__5okdb"};